import React from "react";
import Icon from "../../icons/Icon";
import classNames from "classnames";
import { ConnectDragSource } from "react-dnd";
import { TodoChecklistTemplateCategory } from "../../../models/task";

type ChecklistCategoryItemProps = {
  isSelected: boolean;
  category: TodoChecklistTemplateCategory;
  onDelete?: (id: string) => void;
  onClick?: (category: TodoChecklistTemplateCategory) => void;
  dragRef: ConnectDragSource;
};

const ChecklistCategoryItem: React.FC<ChecklistCategoryItemProps> = (props) => {
  const { isSelected, category, onDelete, onClick, dragRef } = props;

  const getItemClass = (): string => {
    return classNames("checklist-list-item", {
      "checklist-category-selected": isSelected,
    });
  };

  const handleDelete = React.useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();

      onDelete && onDelete(category._id);
    },
    [onDelete, category]
  );

  const handleClick = React.useCallback(() => {
    return onClick && onClick(category);
  }, [onClick, category]);

  return (
    <div className={getItemClass()} onClick={handleClick} ref={dragRef}>
      <div className="item-name">{category.name}</div>
      <div className="right-side">
        {!!onDelete && (
          <div className="remove-action" onClick={handleDelete}>
            <Icon name="clear" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ChecklistCategoryItem;
